import { useSharedValue } from 'react-native-reanimated';
import { useMemo } from 'react';
const useGenerateValues = () => {
    const prevSmoothing = useSharedValue(0);
    const currSmoothing = useSharedValue(0);
    const progress = useSharedValue(1);
    const dotScale = useSharedValue(0);
    const originalX = useSharedValue('');
    const originalY = useSharedValue('');
    const pathOpacity = useSharedValue(1);
    const layoutSize = useSharedValue({ width: 0, height: 0 });
    const state = useSharedValue(0);
    const positionX = useSharedValue(0);
    const positionY = useSharedValue(0);
    const prevData = useSharedValue([]);
    const currData = useSharedValue([]);
    const prevDataFiltered = useSharedValue([]);
    const currDataFiltered = useSharedValue([]);
    return useMemo(() => ({
        currSmoothing,
        dotScale,
        layoutSize,
        originalX,
        originalY,
        pathOpacity,
        positionX,
        positionY,
        prevSmoothing,
        progress,
        state,
        prevData,
        currData,
        prevDataFiltered,
        currDataFiltered,
    }), 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
};
export default useGenerateValues;
